import { lazy, Suspense } from "react";
import Page from "@jumbo/shared/Page";
import otherGoodsMiddleware from "./middleware/auth/otherGoodsValidRoute";

// ✅ Lazy load pages
const ListPurchase = lazy(() => import("app/pages/Inventory/other goods/ListOtherGoods"));
const AddOtherGoods = lazy(() => import("app/pages/Inventory/other goods/AddOtherGoods"));
const EditOtherGoods = lazy(() => import("app/pages/Inventory/other goods/EditOtherGoods"));

export const otherGoodsRoutes = [
  {
    middleware: [
      {
        element: otherGoodsMiddleware,
        fallbackPath: "/dashboard",
      },
    ],
    routes: [
      {
        path: "/dashboard/inventory/othergoods",
        element: (
          <Suspense fallback={<div>Loading...</div>}>
            <Page component={ListPurchase} layout="vertical-default" />
          </Suspense>
        ),
      },
      {
        path: "/dashboard/inventory/othergoods/add",
        element: (
          <Suspense fallback={<div>Loading...</div>}>
            <Page component={AddOtherGoods} layout="vertical-default" />
          </Suspense>
        ),
      },
      {
        path: "/dashboard/inventory/othergoods/edit",
        element: (
          <Suspense fallback={<div>Loading...</div>}>
            <Page component={EditOtherGoods} layout="vertical-default" />
          </Suspense>
        ),
      },
    ],
  },
];
